<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Cabinet Features</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (drainPanSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Drain Pan:</label>
            <select class="halfWidthInputField" #drainPanInput
              [class.invalidConfigurationSelection]="isInvalidSelection(drainPanSelection.Name)"
              (change)="selectionChanged(drainPanSelection, drainPanInput.value)"
              [value]="drainPanSelection.Value.toString()">
              @for (allowable of drainPanSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="drainPanSelection.Value && drainPanSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (dripLipSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(dripLipSelection.Name)"
            for="dripLipInput" class="halfWidthInputLabel">Drip Lip:</label>
            <input type="checkbox" class="checkboxInput" id="dripLipInput"
              #dripLipInput [checked]="'true' === dripLipSelection.Value"
              (change)="selectionChanged(dripLipSelection, dripLipInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (cabinetInsulationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Cabinet Insulation:</label>
            <select class="halfWidthInputField" #cabinetInsulationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetInsulationSelection.Name)"
              (change)="selectionChanged(cabinetInsulationSelection, cabinetInsulationInput.value)"
              [value]="cabinetInsulationSelection.Value.toString()">
              @for (allowable of cabinetInsulationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetInsulationSelection.Value && cabinetInsulationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (tellTailSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(tellTailSelection.Name)"
            for="tellTailInput" class="halfWidthInputLabel">Secondary Drain Connection:</label>
            <input type="checkbox" class="checkboxInput" id="tellTailInput"
              #tellTailInput [checked]="'true' === tellTailSelection.Value"
              (change)="selectionChanged(tellTailSelection, tellTailInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (valvePackageEnclosureSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Valve Package Enclosure:</label>
            <select class="halfWidthInputField" #valvePackageEnclosureInput
              [class.invalidConfigurationSelection]="isInvalidSelection(valvePackageEnclosureSelection.Name)"
              (change)="selectionChanged(valvePackageEnclosureSelection, valvePackageEnclosureInput.value)"
              [value]="valvePackageEnclosureSelection.Value.toString()">
              @for (allowable of valvePackageEnclosureSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="valvePackageEnclosureSelection.Value && valvePackageEnclosureSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (mountingLegsSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(mountingLegsSelection.Name)"
            for="mountingLegsInput" class="halfWidthInputLabel">Mounting Legs:</label>
            <input type="checkbox" class="checkboxInput" id="mountingLegsInput"
              #mountingLegsInput [checked]="'true' === mountingLegsSelection.Value"
              (change)="selectionChanged(mountingLegsSelection, mountingLegsInput.checked.toString())">
          </span>
        }
      </div>
    </div>
  }
</div>
